export const all_routes = {
  login: "/login",
  register: "/register",
  dashboard: "/dashboard",
  verifyOtp: "/verify-otp",
  PatientFamilyMember: "/patient-family-member",
  Appointment: "/appointment",
  appointmentList: "/appointmentList",
  docterDashboard: "/docterDashboard",
  rescheduleAppointment: "/reschedule-Appointment",
  myVitalsReport: "/my-vital-reports",
  aiChatSummaryList: "/ai-chat-summary-list",
  aiChatSummaryLogs: "/ai-chat-summary-logs",
  reports: "/reports",
  medication: "/medication",
  addMedication: "/addEditMedication",
  medicationDetail: "/medication-detail",
  patientProfile: "/profile",
  home: "/",
  aiChatSummaryLogs: "/ai-chat-summary-logs",
  aiChatSummaryLogsWithSession: "/ai-chat-summary-logs/:sessionId",
  coinWallet: "/coin-wallet",
  calendar: "/calendar",
  medicationDetail: "/medication-details"
};
